"use strict";
/*

Dev notes:

    Refactor plans:
        - Improve how tracks and panels are laid out; should not need to manually call layout after each change
        - Panels should be an array not a set
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IconButton_1 = require("@material-ui/core/IconButton");
var Add_1 = require("@material-ui/icons/Add");
var Close_1 = require("@material-ui/icons/Close");
var ExpandLess_1 = require("@material-ui/icons/ExpandLess");
var ExpandMore_1 = require("@material-ui/icons/ExpandMore");
var ArrowDropUp_1 = require("@material-ui/icons/ArrowDropUp");
var ArrowDropDown_1 = require("@material-ui/icons/ArrowDropDown");
var Animator_1 = require("../Animator");
var Object2D_1 = require("engine/ui/Object2D");
var Rect_1 = require("engine/ui/Rect");
var Text_1 = require("engine/ui/Text");
var GenomeVisualizer_1 = require("../GenomeVisualizer");
var ReactObject_1 = require("./core/ReactObject");
var Panel_1 = require("./Panel");
var UIConstants_1 = require("./UIConstants");
var font_1 = require("./font");
var StyleProxy_1 = require("./util/StyleProxy");
var TrackViewer = /** @class */ (function (_super) {
    __extends(TrackViewer, _super);
    function TrackViewer() {
        var _this = _super.call(this) || this;
        // layout settings
        _this.trackHeaderWidth = 180;
        _this.panelHeaderHeight = 50;
        _this.trackButtonWidth = 50;
        _this.spacing = {
            x: 5,
            y: 5
        };
        _this.xAxisHeight = 40; // height excluding spacing
        _this.minPanelWidth = 35;
        _this.minTrackHeight = 35;
        _this.allowNewPanels = true;
        _this._removableTracks = true; // use setRemovableTracks
        _this.reorderTracks = false;
        _this.panels = new Set();
        _this.tracks = new Array();
        _this.panelEdges = new Array();
        _this.rowOffsetY = 0;
        _this.masks = new Array();
        _this.trackStyleProxies = {};
        /**
         * Removes the row from the scene and cleans up resources
         *
         * **Should only be called after closeTrackRow**
         */
        _this.deleteTrack = function (track) {
            _this.deleteRowObject(track.rowObject);
            var i = _this.tracks.indexOf(track);
            if (i !== -1) {
                _this.tracks.splice(i, 1);
            }
        };
        _this.deleteRowObject = function (rowObject) {
            var e_1, _a, e_2, _b, e_3, _c;
            // remove trackRow elements from scene
            _this.grid.remove(rowObject.header);
            _this.grid.remove(rowObject.closeButton);
            _this.grid.remove(rowObject.resizeHandle);
            try {
                // remove track tiles from panels and release resources
                for (var _d = __values(_this.panels), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var panel = _e.value;
                    try {
                        for (var _f = __values(rowObject.trackViews), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var track = _g.value;
                            panel.removeTrackView(track);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                // release track tile resources
                for (var _j = __values(rowObject.trackViews), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var trackView = _k.value;
                    trackView.releaseGPUResources();
                    rowObject.removeTrackView(trackView);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_3) throw e_3.error; }
            }
        };
        /**
         * Removes the panel from the scene and cleans up resources
         *
         * **Should only be called after closePanel**
         */
        _this.deletePanel = function (panel) {
            var e_4, _a, e_5, _b;
            if (!panel.closing) {
                console.warn('cleanupPanel() called before closing the panel');
                _this.closePanel(panel, false);
            }
            // remove from panel list
            if (!_this.panels.has(panel)) {
                console.error('Cleanup executed twice on a panel');
                return;
            }
            _this.panels.delete(panel);
            _this.onPanelsChanged();
            // stop any active animations on the panel
            Animator_1.default.stop(panel);
            // remove any open cleanupPanel panel callbacks
            Animator_1.default.removeAnimationCompleteCallbacks(panel, 'relativeW', _this.deletePanel);
            // remove the panel from the scene
            _this.grid.remove(panel);
            try {
                // delete track tiles from the track
                // (we can leave them in the scene-graph of the panel and the GC should still cull them all)
                for (var _c = __values(panel.trackViews), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var trackView = _d.value;
                    // destroy the track object
                    trackView.releaseGPUResources();
                    // remove track object from panel
                    panel.remove(trackView);
                    try {
                        // remove track object from all track rows
                        for (var _e = __values(_this.tracks), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var track = _f.value;
                            var rowObject = track.rowObject;
                            rowObject.removeTrackView(trackView);
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_4) throw e_4.error; }
            }
            panel.releaseGPUResources();
            // strictly we don't need to do this but listener bugs may prevent the GC from clearing the panel
            panel.removeAllListeners(true);
        };
        _this.onAnimationStep = function () {
            var e_6, _a;
            var maxX = 1;
            try {
                for (var _b = __values(_this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var panel = _c.value;
                    maxX = Math.max(panel.relativeX + panel.relativeW, maxX);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            _this.addPanelButton.relativeX = maxX;
        };
        _this.onResize = function (e) {
            _this.applyOverflowLimits();
            _this.layoutTrackRows(false);
        };
        // local state for grid-resizing
        _this._resizingPanels = new Set();
        _this._resizingTracks = new Set();
        _this.render = false;
        // fill parent dimensions
        _this.relativeW = 1;
        _this.relativeH = 1;
        _this.grid = new Rect_1.default(0, 0, [0.9, 0.9, 0.9, 1]); // grid is Rect type for debug display
        _this.grid.render = false;
        _this.add(_this.grid);
        _this.initializeDragPanning();
        _this.initializeGridResizing();
        _this.addPanelButton = new ReactObject_1.default(React.createElement(TrackViewer.AddPanelButton, { onClick: function () {
                _this.addPanel({ contig: 'chr1', x0: 0, x1: 249e6 }, true);
            } }), _this.panelHeaderHeight, _this.trackButtonWidth);
        _this.addPanelButton.x = _this.spacing.x * 0.5;
        _this.addPanelButton.containerStyle = {
            zIndex: 3,
        };
        _this.addPanelButton.relativeX = 1;
        _this.addPanelButton.originY = -1;
        _this.addPanelButton.y = -_this.xAxisHeight - _this.spacing.x * 0.5;
        _this.grid.add(_this.addPanelButton);
        var maskStyle = {
            backgroundColor: '#fff',
            zIndex: 2,
            width: '100%',
            height: '100%',
        };
        var leftTrackMask = new ReactObject_1.default(React.createElement("div", { style: maskStyle }), _this.trackHeaderWidth + _this.spacing.x, _this.panelHeaderHeight + _this.xAxisHeight - 0.5 * _this.spacing.y);
        var rightTrackMask = new ReactObject_1.default(React.createElement("div", { style: maskStyle }), _this.panelHeaderHeight + 1.5 * _this.spacing.x, _this.panelHeaderHeight + _this.xAxisHeight - 0.5 * _this.spacing.y);
        rightTrackMask.relativeX = 1;
        rightTrackMask.originX = -1;
        _this.masks = [leftTrackMask, rightTrackMask];
        // nothing to display text
        _this.nothingToDisplay = new Text_1.default(font_1.OpenSansRegular, '', 20, [0.6, 0.6, 0.6, 1.0]);
        _this.nothingToDisplay.z = 10;
        // center
        _this.nothingToDisplay.originX = -0.5;
        _this.nothingToDisplay.originY = -0.5;
        _this.nothingToDisplay.relativeX = 0.5;
        _this.nothingToDisplay.relativeY = 0.5;
        _this.resetNothingToDisplayText();
        window.addEventListener('resize', _this.onResize);
        // initialize with empty configuration
        _this.setConfiguration({
            panels: [],
            tracks: [],
        });
        return _this;
    }
    TrackViewer.prototype.setConfiguration = function (state) {
        var e_7, _a, e_8, _b, e_9, _c, e_10, _d;
        var panels = state.panels || [];
        // hide/show add panel button
        var clampToTracks = state.clampToTracks == null ? false : state.clampToTracks;
        this.allowNewPanels = state.allowNewPanels == null ? false : state.allowNewPanels;
        this.reorderTracks = state.reorderTracks == null ? false : state.reorderTracks;
        this.setRemovableTracks(state.removableTracks == null ? true : state.removableTracks);
        this.grid.toggleChild(this.addPanelButton, this.allowNewPanels);
        // Panels
        // clear current panels
        var currentPanels = new Set(this.panels);
        try {
            for (var currentPanels_1 = __values(currentPanels), currentPanels_1_1 = currentPanels_1.next(); !currentPanels_1_1.done; currentPanels_1_1 = currentPanels_1.next()) {
                var panel = currentPanels_1_1.value;
                this.closePanel(panel, false);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (currentPanels_1_1 && !currentPanels_1_1.done && (_a = currentPanels_1.return)) _a.call(currentPanels_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        // clear current tracks
        var currentTracks = new Set(this.tracks);
        try {
            for (var currentTracks_1 = __values(currentTracks), currentTracks_1_1 = currentTracks_1.next(); !currentTracks_1_1.done; currentTracks_1_1 = currentTracks_1.next()) {
                var track = currentTracks_1_1.value;
                this.closeTrack(track, false);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (currentTracks_1_1 && !currentTracks_1_1.done && (_b = currentTracks_1.return)) _b.call(currentTracks_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
        // create panels
        for (var i = 0; i < panels.length; i++) {
            var panelState = panels[i];
            this.addPanel(panelState.location, false);
        }
        // determine what width to set panels that have no width specified
        var unassignedWidthRemaining = 1;
        var unassignedWidthCount = 0;
        for (var i = 0; i < panels.length; i++) {
            var panelState = panels[i];
            if (panelState.width != null) {
                unassignedWidthRemaining -= panelState.width;
            }
            else {
                unassignedWidthCount++;
            }
        }
        var unassignedWidthPanel = unassignedWidthRemaining / unassignedWidthCount;
        // set panel edges from state widths
        var e = 0;
        for (var i = 0; i < panels.length; i++) {
            var panelState = panels[i];
            this.panelEdges[i] = e;
            if (panelState.width != null) {
                e += panelState.width;
            }
            else {
                e += unassignedWidthPanel;
            }
        }
        this.layoutPanels(false);
        // create rows
        if (state.tracks != null) {
            try {
                for (var _e = __values(state.tracks), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var track = _f.value;
                    this.addTrack(track, false);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        try {
            // apply clampToTracks
            for (var _g = __values(this.panels), _j = _g.next(); !_j.done; _j = _g.next()) {
                var panel = _j.value;
                panel.clampToTracks = clampToTracks;
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_d = _g.return)) _d.call(_g);
            }
            finally { if (e_10) throw e_10.error; }
        }
        this.layoutTrackRows(false);
        this.layoutGridContainer();
        this.onPanelsChanged();
    };
    TrackViewer.prototype.getConfiguration = function () {
        var e_11, _a, e_12, _b;
        var clampToTracks = false;
        var panels = new Array();
        try {
            for (var _c = __values(this.panels), _d = _c.next(); !_d.done; _d = _c.next()) {
                var panel = _d.value;
                clampToTracks = panel.clampToTracks;
                var width = this.panelEdges[panel.column + 1] - this.panelEdges[panel.column];
                panels.push({
                    location: {
                        contig: panel.contig,
                        x0: panel.x0,
                        x1: panel.x1,
                    },
                    width: width,
                });
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_11) throw e_11.error; }
        }
        var tracks = new Array();
        try {
            for (var _e = __values(this.tracks), _f = _e.next(); !_f.done; _f = _e.next()) {
                var track = _f.value;
                tracks.push(__assign({}, track.model, { heightPx: track.heightPx }));
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_12) throw e_12.error; }
        }
        return {
            allowNewPanels: this.allowNewPanels,
            removableTracks: this._removableTracks,
            reorderTracks: this.reorderTracks,
            clampToTracks: clampToTracks,
            panels: panels,
            tracks: tracks,
        };
    };
    TrackViewer.prototype.setDataSource = function (dataSource) {
        var e_13, _a;
        this.dataSource = dataSource;
        try {
            for (var _b = __values(this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                var panel = _c.value;
                panel.setDataSource(dataSource);
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_13) throw e_13.error; }
        }
    };
    // track-viewer state deltas
    TrackViewer.prototype.addTrack = function (model, animate) {
        var _this = this;
        if (animate === void 0) { animate = true; }
        var e_14, _a;
        var trackClasses = GenomeVisualizer_1.default.getTrackType(model.type);
        trackClasses.tileLoaderClass.getAvailableContigs(model).then(function (contigs) {
            var e_15, _a;
            try {
                for (var contigs_1 = __values(contigs), contigs_1_1 = contigs_1.next(); !contigs_1_1.done; contigs_1_1 = contigs_1.next()) {
                    var contig = contigs_1_1.value;
                    _this.dataSource.addContig(contig);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (contigs_1_1 && !contigs_1_1.done && (_a = contigs_1.return)) _a.call(contigs_1);
                }
                finally { if (e_15) throw e_15.error; }
            }
            // if no panels have been specified, create one from the first available contig
            if (_this.panels.size === 0) {
                _this.dataSource.getContigs().then(function (contigs) {
                    if (contigs.length > 0 && _this.panels.size === 0) {
                        _this.addPanel({
                            contig: contigs[0].id,
                            x0: contigs[0].startIndex,
                            x1: contigs[0].startIndex + contigs[0].span
                        }, false);
                    }
                });
            }
        });
        var defaultTrackHeight = trackClasses.trackObjectClass.getDefaultHeightPx != null ? trackClasses.trackObjectClass.getDefaultHeightPx(model) : 100;
        var expandable = trackClasses.trackObjectClass.getExpandable != null ? trackClasses.trackObjectClass.getExpandable(model) : true;
        var heightPx = model.heightPx != null ? model.heightPx : defaultTrackHeight;
        // create a track and add the header element to the grid
        var track = new Track(model, heightPx, function (name) {
            if (name === 'heightPx') {
                _this.emit('track-resize', track);
            }
            _this.layoutTrackRows(true);
        });
        var rowObject = new RowObject(model, heightPx, expandable, this.spacing, function () { return _this.closeTrack(track); }, function () { return _this.moveTrackUp(track); }, function () { return _this.moveTrackDown(track); }, function (h) { return track.heightPx = h; }, function () { return track.heightPx; }, this.reorderTracks);
        track.rowObject = rowObject;
        try {
            // add track tile to all panels
            for (var _b = __values(this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                var panel = _c.value;
                this.createTrackObject(model, panel, rowObject);
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_14) throw e_14.error; }
        }
        var styleProxy = this.trackStyleProxies[track.model.type];
        if (styleProxy) {
            track.applyStyle(styleProxy);
        }
        this.tracks.push(track);
        rowObject.closeButton.relativeX = 1;
        rowObject.closeButton.x = -this.spacing.x;
        rowObject.closeButton.w = 50;
        rowObject.header.x = -this.trackHeaderWidth + this.spacing.x * 0.5;
        rowObject.header.w = this.trackHeaderWidth;
        // position the resize handle to span the full width of the viewer 
        rowObject.resizeHandle.relativeW = 1;
        rowObject.resizeHandle.x = -this.trackHeaderWidth;
        rowObject.resizeHandle.w = this.trackHeaderWidth;
        rowObject.resizeHandle.addInteractionListener('dragstart', function (e) {
            if (e.isPrimary && e.buttonState === 1) {
                e.preventDefault();
                _this.startResizingTrack(track);
            }
        });
        rowObject.resizeHandle.addInteractionListener('dragend', function (e) {
            if (e.isPrimary) {
                e.preventDefault();
                _this.endResizingTrack(track);
            }
        });
        rowObject.setResizable(true);
        this.grid.add(rowObject.header);
        this.grid.add(rowObject.resizeHandle);
        if (this._removableTracks) {
            this.grid.add(rowObject.closeButton);
        }
        // first instantaneously the y position of the track and override h to 0
        this.layoutTrackRows(false, rowObject);
        rowObject.h = 0;
        // then animate all the tracks to the new layout
        this.layoutTrackRows(animate);
        return track;
    };
    TrackViewer.prototype.closeTrack = function (track, animate, onComplete) {
        var _this = this;
        if (animate === void 0) { animate = true; }
        if (onComplete === void 0) { onComplete = function () { }; }
        // first set height to 0, when the animation is complete, remove the row's resources
        if (this.tracks.indexOf(track) === -1)
            return; // this trackRow has already been removed
        var trackInternal = track;
        var rowObject = trackInternal.rowObject;
        if (trackInternal.closing) {
            return;
        }
        track.opacity = 0;
        trackInternal.closing = true;
        rowObject.disableInteraction();
        rowObject.setResizable(false);
        this.endResizingTrack(track);
        // animate height to 0 and delete the row when complete
        track.heightPx = 0;
        if (animate) {
            Animator_1.default.addAnimationCompleteCallback(rowObject, 'h', function () {
                _this.deleteTrack(track);
                onComplete();
            }, true);
        }
        else {
            Animator_1.default.stop(rowObject);
            this.deleteTrack(track);
            onComplete();
        }
        this.layoutTrackRows(animate);
    };
    TrackViewer.prototype.setTrackIndex = function (track, index, animate) {
        // re-orders tracks in this.tracks[] and then calls this.layoutTrackRows(animate);
        if (animate === void 0) { animate = true; }
        // apply array bounds check
        index = Math.min(Math.max(index, 0), this.tracks.length - 1);
        var currentIndex = this.tracks.indexOf(track);
        // remove from tracks[] array (index -1 is fine and does nothing)
        this.tracks.splice(currentIndex, 1);
        // insert at index
        this.tracks.splice(index, 0, track);
        // now this.tracks[] has been changed, let's re-layout the tracks
        this.layoutTrackRows(animate);
    };
    TrackViewer.prototype.moveTrackUp = function (track, animate) {
        if (animate === void 0) { animate = true; }
        var currentIndex = this.tracks.indexOf(track);
        if (currentIndex !== -1) {
            this.setTrackIndex(track, currentIndex - 1, animate);
        }
    };
    TrackViewer.prototype.moveTrackDown = function (track, animate) {
        if (animate === void 0) { animate = true; }
        var currentIndex = this.tracks.indexOf(track);
        if (currentIndex !== -1) {
            this.setTrackIndex(track, currentIndex + 1, animate);
        }
    };
    TrackViewer.prototype.addPanel = function (location, animate) {
        var _this = this;
        if (animate === void 0) { animate = true; }
        var e_16, _a;
        var edges = this.panelEdges;
        var newColumnIndex = Math.max(edges.length - 1, 0);
        // add a new column edge, overflow the grid so the panel extends off the screen
        if (edges.length === 0)
            edges.push(0);
        var newWidth = newColumnIndex == 0 ? 1 : 1 / newColumnIndex;
        var newEdge = 1 + newWidth;
        edges.push(newEdge);
        // create panel object and add header to the scene graph
        var panel = new Panel_1.default(function (p) { return _this.closePanel(p, true); }, this.spacing, this.panelHeaderHeight, this.xAxisHeight, this.dataSource);
        panel.setContig(location.contig);
        panel.setRange(location.x0, location.x1);
        panel.addEventListener('panel-event', function (event) {
            _this.emit(event.type, event);
        });
        panel.column = newColumnIndex; // @! should use array of panels instead of column field
        panel.relativeH = 1; // fill the full grid height
        this.grid.add(panel);
        if (this.panelStyleProxy != null) {
            panel.applyStyle(this.panelStyleProxy);
        }
        try {
            // initialize tracks for this panel
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                this.createTrackObject(track.model, panel, track.rowObject);
            }
        }
        catch (e_16_1) { e_16 = { error: e_16_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_16) throw e_16.error; }
        }
        this.panels.add(panel);
        this.onPanelsChanged();
        panel.resizeHandle.addInteractionListener('dragstart', function (e) {
            if (e.isPrimary && e.buttonState === 1) {
                e.preventDefault();
                _this.startResizingPanel(panel);
            }
        });
        panel.resizeHandle.addInteractionListener('dragend', function (e) {
            if (e.isPrimary) {
                e.preventDefault();
                _this.endResizingPanel(panel);
            }
        });
        panel.addEventListener('axisPointerUpdate', function (axisPointers) {
            var e_17, _a;
            try {
                for (var _b = __values(_this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var p = _c.value;
                    if (p === panel)
                        continue;
                    p.setSecondaryAxisPointers(axisPointers);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_17) throw e_17.error; }
            }
        });
        // set initial position
        this.layoutPanels(false, panel);
        // scale the edges down to fit within the grid space
        var multiplier = 1 / newEdge;
        for (var e = 0; e < edges.length; e++) {
            edges[e] *= multiplier;
        }
        this.layoutPanels(animate);
    };
    TrackViewer.prototype.closePanel = function (panel, animate, onComplete) {
        var _this = this;
        if (animate === void 0) { animate = true; }
        if (onComplete === void 0) { onComplete = function () { }; }
        var e_18, _a;
        if (panel.closing) {
            return;
        }
        var edges = this.panelEdges;
        panel.closing = true;
        // if the panel is being resized, stop it
        this.endResizingPanel(panel);
        // remove column from edges
        this.removeColumn(edges, panel.column);
        try {
            // update column indexes of remaining panels
            for (var _b = __values(this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (p.column > panel.column) {
                    p.column = p.column - 1;
                }
            }
        }
        catch (e_18_1) { e_18 = { error: e_18_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_18) throw e_18.error; }
        }
        this.layoutPanels(animate);
        // animate panel's width to 0, after which delete the panel
        if (animate) {
            Animator_1.default.addAnimationCompleteCallback(panel, 'relativeW', function () {
                _this.deletePanel(panel);
                onComplete();
            }, true);
            Animator_1.default.springTo(panel, { relativeW: 0 }, UIConstants_1.DEFAULT_SPRING);
        }
        else {
            Animator_1.default.stop(panel);
            this.deletePanel(panel);
            onComplete();
        }
        // clear edges if there's less then 2, this allows edges to be re-initialized
        if (edges.length < 2) {
            edges.length = 0;
        }
    };
    TrackViewer.prototype.getTracks = function () {
        return this.tracks.slice();
    };
    TrackViewer.prototype.getPanels = function () {
        return new Set(this.panels);
    };
    TrackViewer.prototype.setNothingToDisplayText = function (string) {
        this.nothingToDisplay.string = string;
    };
    TrackViewer.prototype.resetNothingToDisplayText = function () {
        this.nothingToDisplay.string = 'Loading';
    };
    TrackViewer.prototype.refreshStyle = function () {
        var e_19, _a;
        this.refreshPanelStyle();
        try {
            // update style for tracks if any of the style attributes are changed
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                var styleProxy = this.trackStyleProxies[track.model.type];
                if (styleProxy == null)
                    continue;
                track.applyStyle(styleProxy);
            }
        }
        catch (e_19_1) { e_19 = { error: e_19_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_19) throw e_19.error; }
        }
    };
    TrackViewer.prototype.getStyleNodes = function () {
        var _this = this;
        var e_20, _a;
        // add style node for panel
        var styleNodes = new Array([
            React.createElement("div", { key: "trackViewer-panel", className: "hpgv_panel", ref: function (node) {
                    _this.setPanelStyleNode(node);
                } })
        ]);
        var _loop_1 = function (trackType) {
            var trackObjectClass = GenomeVisualizer_1.default.getTrackType(trackType).trackObjectClass;
            styleNodes.push(React.createElement("div", { key: trackType, className: "hpgv_track hpgv_track-" + trackType, ref: function (node) {
                    _this.setTrackStyleNode(trackType, node);
                } }, trackObjectClass.styleNodes));
        };
        try {
            // add track nodes
            for (var _b = __values(GenomeVisualizer_1.default.getTrackTypes()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trackType = _c.value;
                _loop_1(trackType);
            }
        }
        catch (e_20_1) { e_20 = { error: e_20_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_20) throw e_20.error; }
        }
        return styleNodes;
    };
    TrackViewer.prototype.getContentHeight = function () {
        return this.grid.y + this.getTotalRowHeight() + this.spacing.y;
    };
    TrackViewer.prototype.createTrackObject = function (model, panel, rowObject) {
        var _this = this;
        var trackObjectClass = GenomeVisualizer_1.default.getTrackType(model.type).trackObjectClass;
        var trackObject = new trackObjectClass(model);
        panel.addTrackView(trackObject);
        rowObject.addTrackView(trackObject);
        // unwrap and forward track events, so you can do, trackViewer.addEventListener(<track-event>, ...)
        trackObject.addEventListener('track-event', function (eventData) {
            _this.emit(eventData.type, eventData);
        });
    };
    TrackViewer.prototype.setTrackStyleNode = function (trackType, node) {
        var _this = this;
        // end any existing style proxy callbacks
        if (this.trackStyleProxies[trackType] != null) {
            this.trackStyleProxies[trackType].removeAllObservers();
        }
        var styleProxy = this.trackStyleProxies[trackType] = new StyleProxy_1.StyleProxy(node);
        styleProxy.observeAllStyle(function () { return _this.refreshTrackStyle(trackType); });
        this.refreshTrackStyle(trackType);
    };
    TrackViewer.prototype.setPanelStyleNode = function (node) {
        var _this = this;
        if (this.panelStyleProxy != null) {
            this.panelStyleProxy.removeAllObservers();
        }
        this.panelStyleProxy = new StyleProxy_1.StyleProxy(node);
        this.panelStyleProxy.observeAllStyle(function () { return _this.refreshPanelStyle(); });
        this.refreshPanelStyle();
    };
    TrackViewer.prototype.refreshTrackStyle = function (type) {
        var e_21, _a;
        var styleProxy = this.trackStyleProxies[type];
        if (styleProxy == null)
            return;
        ;
        try {
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                if (track.model.type === type) {
                    track.applyStyle(styleProxy);
                }
            }
        }
        catch (e_21_1) { e_21 = { error: e_21_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_21) throw e_21.error; }
        }
    };
    TrackViewer.prototype.refreshPanelStyle = function () {
        var e_22, _a;
        if (this.panelStyleProxy == null)
            return;
        try {
            for (var _b = __values(this.panels), _c = _b.next(); !_c.done; _c = _b.next()) {
                var panel = _c.value;
                panel.applyStyle(this.panelStyleProxy);
            }
        }
        catch (e_22_1) { e_22 = { error: e_22_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_22) throw e_22.error; }
        }
    };
    TrackViewer.prototype.onPanelsChanged = function () {
        var e_23, _a;
        // hide/show masks & nothing to display message
        var nothingToDisplay = this.panels.size === 0;
        this.toggleChild(this.nothingToDisplay, nothingToDisplay);
        // only show tracks and masks when showing panels and content
        this.toggleChild(this.grid, !nothingToDisplay);
        try {
            for (var _b = __values(this.masks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mask = _c.value;
                this.toggleChild(mask, !nothingToDisplay);
            }
        }
        catch (e_23_1) { e_23 = { error: e_23_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_23) throw e_23.error; }
        }
    };
    TrackViewer.prototype.setRemovableTracks = function (state) {
        var e_24, _a;
        this._removableTracks = state;
        try {
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                var rowObject = track.rowObject;
                this.grid.toggleChild(rowObject.closeButton, this._removableTracks);
            }
        }
        catch (e_24_1) { e_24 = { error: e_24_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_24) throw e_24.error; }
        }
        this.layoutGridContainer();
    };
    TrackViewer.prototype.layoutPanels = function (animate, singlePanelOnly) {
        var e_25, _a, e_26, _b;
        // count open panels
        var openPanelCount = 0;
        try {
            for (var _c = __values(this.panels), _d = _c.next(); !_d.done; _d = _c.next()) {
                var panel = _d.value;
                if (!panel.closing)
                    openPanelCount++;
            }
        }
        catch (e_25_1) { e_25 = { error: e_25_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_25) throw e_25.error; }
        }
        try {
            // panels are only closable if more than 1 are open
            for (var _e = __values(this.panels), _f = _e.next(); !_f.done; _f = _e.next()) {
                var panel = _f.value;
                panel.closable = openPanelCount > 1;
                panel.setResizable(panel.column < (this.panelEdges.length - 2) && !panel.closing);
                // animate panels to column positions
                if (singlePanelOnly === undefined || (singlePanelOnly === panel)) {
                    var edges = this.panelEdges;
                    var relativeX = edges[panel.column];
                    var relativeW = panel.closing ? 0 : edges[panel.column + 1] - edges[panel.column];
                    if (animate) {
                        Animator_1.default.springTo(panel, { relativeX: relativeX, relativeW: relativeW }, UIConstants_1.DEFAULT_SPRING);
                    }
                    else {
                        Animator_1.default.stop(panel, ['relativeX', 'relativeW']);
                        panel.relativeX = relativeX;
                        panel.relativeW = relativeW;
                    }
                }
            }
        }
        catch (e_26_1) { e_26 = { error: e_26_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_26) throw e_26.error; }
        }
    };
    TrackViewer.prototype.layoutTrackRows = function (animate, singleTrackRowOnly) {
        var e_27, _a;
        var y = 0;
        try {
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var track = _c.value;
                var h = track.heightPx;
                var rowObject = track.rowObject;
                if (singleTrackRowOnly === undefined || (singleTrackRowOnly === rowObject)) {
                    if (animate) {
                        Animator_1.default.springTo(rowObject, { y: y, h: h, opacity: track.opacity }, UIConstants_1.DEFAULT_SPRING);
                    }
                    else {
                        Animator_1.default.stop(rowObject, ['y', 'h', 'opacity']);
                        rowObject.y = y + this.rowOffsetY;
                        rowObject.h = h;
                    }
                }
                y += track.heightPx;
            }
        }
        catch (e_27_1) { e_27 = { error: e_27_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_27) throw e_27.error; }
        }
        // we manually set the grid height since it doesn't automatically wrap to content
        this.grid.h = y + this.spacing.y * 0.5 + this.rowOffsetY;
    };
    /**
     * Remove a column from a set of edges in a physically natural way; the edges either side together as if either side was expanding under spring forces to fill the empty space
     */
    TrackViewer.prototype.removeColumn = function (edges, index) {
        if (index >= edges.length || index < 0)
            return false;
        var leftmostEdge = edges[0];
        var rightmostEdge = edges[edges.length - 1];
        var leftEdge = edges[index];
        var rightEdge = edges[index + 1] || rightmostEdge;
        var lSpan = leftEdge - leftmostEdge;
        var rSpan = rightmostEdge - rightEdge;
        var totalSpan = rSpan + lSpan;
        // determine where the left and right edges should come together
        var relativeMergePoint = totalSpan == 0 ? 0.5 : (lSpan / totalSpan);
        var edgeMergeTarget = relativeMergePoint * (rightEdge - leftEdge) + leftEdge;
        // evenly redistribute all the edges ether side to fill the new space
        var newRSpan = rightmostEdge - edgeMergeTarget;
        var newLSpan = edgeMergeTarget - leftmostEdge;
        var rSpanMultiplier = rSpan == 0 ? 0 : newRSpan / rSpan;
        for (var i = index + 1; i < edges.length; i++) {
            edges[i] = edgeMergeTarget + (edges[i] - rightEdge) * rSpanMultiplier;
        }
        var lSpanMultiplier = newLSpan / lSpan;
        for (var i = 0; i < index; i++) {
            edges[i] = leftmostEdge + (edges[i] - leftmostEdge) * lSpanMultiplier;
        }
        // remove edge from list
        edges.splice(index, 1);
        return true;
    };
    TrackViewer.prototype.onAdded = function () {
        _super.prototype.onAdded.call(this);
        Animator_1.default.addStepCompleteCallback(this.onAnimationStep);
    };
    TrackViewer.prototype.onRemoved = function () {
        _super.prototype.onRemoved.call(this);
        Animator_1.default.removeStepCompleteCallback(this.onAnimationStep);
    };
    TrackViewer.prototype.layoutGridContainer = function () {
        var trackButtonsVisible = this.allowNewPanels || this._removableTracks;
        this.grid.x = this.trackHeaderWidth + this.spacing.x * 0.5;
        this.grid.w =
            -this.trackHeaderWidth - this.spacing.x * 0.5
                // right-side buttons 
                - (trackButtonsVisible ? (this.trackButtonWidth + this.spacing.x * 0.5) : 0);
        this.grid.relativeW = 1;
        this.grid.y = this.panelHeaderHeight + this.spacing.y * 0.5 + this.xAxisHeight;
        // (grid height is set dynamically when laying out tracks)
    };
    TrackViewer.prototype.getTotalRowHeight = function () {
        var e_28, _a;
        // compute total row-height
        var rowHeight = 0;
        try {
            for (var _b = __values(this.tracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var row = _c.value;
                rowHeight += row.heightPx;
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_28) throw e_28.error; }
        }
        return rowHeight;
    };
    // limits rowOffsetY to only overflow region
    TrackViewer.prototype.applyOverflowLimits = function () {
        var maxOffset = 0;
        // determine minOffset from grid overflow
        // assumes grid.h is up to date (requires calling layoutTrackRows(false))
        var trackViewerHeight = this.getComputedHeight();
        var gridViewportHeight = trackViewerHeight - this.grid.y;
        var totoalRowHeight = this.getTotalRowHeight();
        var padding = this.spacing.y;
        var overflow = totoalRowHeight - gridViewportHeight + padding;
        var minOffset = -overflow;
        this.rowOffsetY = Math.min(Math.max(this.rowOffsetY, minOffset), maxOffset);
    };
    TrackViewer.prototype.initializeDragPanning = function () {
        var _this = this;
        var dragStartY = undefined;
        var yOffsetStart = undefined;
        this.addEventListener('dragstart', function (e) {
            dragStartY = e.localY;
            yOffsetStart = _this.rowOffsetY;
        });
        this.addEventListener('dragmove', function (e) {
            if (_this._resizingPanels.size > 0 || _this._resizingTracks.size > 0)
                return;
            var dy = e.localY - dragStartY;
            _this.rowOffsetY = yOffsetStart + dy;
            _this.applyOverflowLimits();
            _this.layoutTrackRows(false);
        });
    };
    /**
     * Setup event listeners to enable resizing of panels and tracks
     */
    TrackViewer.prototype.initializeGridResizing = function () {
        var _this = this;
        var draggedVEdges = {};
        var localY0 = 0;
        this.addInteractionListener('dragstart', function (e) {
            var e_29, _a;
            var resizing = (_this._resizingPanels.size + _this._resizingTracks.size) > 0;
            if (resizing) {
                e.preventDefault();
                e.stopPropagation();
            }
            try {
                for (var _b = __values(_this._resizingPanels), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var panel = _c.value;
                    var i = panel.column + 1;
                    draggedVEdges[i] = {
                        i: i,
                        p0: e.fractionX,
                        e0: _this.panelEdges[i],
                        obj: panel,
                    };
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_29) throw e_29.error; }
            }
            if (e.isPrimary && e.buttonState === 1) {
                localY0 = e.localY;
            }
        });
        this.addInteractionListener('dragmove', function (e) {
            var e_30, _a, e_31, _b, e_32, _c;
            var resized = false;
            var resizing = (_this._resizingPanels.size + _this._resizingTracks.size) > 0;
            if (resizing) {
                e.preventDefault();
                e.stopPropagation();
            }
            for (var k in draggedVEdges) {
                var s = draggedVEdges[k];
                var dx = e.fractionX - s.p0;
                var gridWidthPx = _this.grid.getComputedWidth();
                var minFWidth = _this.minPanelWidth / gridWidthPx;
                var min = ((_this.panelEdges[s.i - 1] + minFWidth) || 0);
                var max = ((_this.panelEdges[s.i + 1] - minFWidth) || 1);
                _this.panelEdges[s.i] = Math.min(Math.max(s.e0 + dx, min), max);
                try {
                    for (var _d = __values(_this.panels), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var p = _e.value;
                        if ((p.column === s.i) || (p.column === (s.i - 1))) {
                            _this.layoutPanels(false, p);
                        }
                    }
                }
                catch (e_30_1) { e_30 = { error: e_30_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_30) throw e_30.error; }
                }
                resized = true;
            }
            if (e.isPrimary) {
                try {
                    for (var _f = __values(_this._resizingTracks), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var entry = _g.value;
                        var deltaY = e.localY - localY0;
                        entry.track.heightPx = Math.max(entry.initialHeightPx + deltaY, _this.minTrackHeight);
                        resized = true;
                    }
                }
                catch (e_31_1) { e_31 = { error: e_31_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_31) throw e_31.error; }
                }
            }
            if (resized) {
                _this.layoutTrackRows(false);
                try {
                    for (var _j = __values(_this._resizingTracks), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var entry = _k.value;
                        _this.emit('track-resize', entry.track);
                    }
                }
                catch (e_32_1) { e_32 = { error: e_32_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                    }
                    finally { if (e_32) throw e_32.error; }
                }
            }
        });
        this.addInteractionListener('dragend', function (e) {
            // cleanup dragged edges state
            for (var k in draggedVEdges) {
                var s = draggedVEdges[k];
                if (!_this._resizingPanels.has(s.obj)) {
                    delete draggedVEdges[k];
                }
            }
        });
    };
    TrackViewer.prototype.startResizingPanel = function (panel) {
        this._resizingPanels.add(panel);
    };
    TrackViewer.prototype.endResizingPanel = function (panel) {
        this._resizingPanels.delete(panel);
    };
    TrackViewer.prototype.startResizingTrack = function (track) {
        this._resizingTracks.add({
            track: track,
            initialHeightPx: track.heightPx,
        });
        this.emit('track-resize-start', track);
    };
    TrackViewer.prototype.endResizingTrack = function (track) {
        var e_33, _a;
        try {
            for (var _b = __values(this._resizingTracks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var entry = _c.value;
                if (entry.track === track) {
                    this._resizingTracks.delete(entry);
                }
            }
        }
        catch (e_33_1) { e_33 = { error: e_33_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_33) throw e_33.error; }
        }
        this.applyOverflowLimits();
        this.layoutTrackRows(false);
        this.emit('track-resize-end', track);
    };
    TrackViewer.TrackCloseButton = function (props) {
        return React.createElement("div", { className: "hpgv_ui-block hpgv_track-close-button", style: __assign({ position: 'relative', height: '100%', width: '100%', overflow: 'hidden', userSelect: 'none' }, props.style) },
            React.createElement("div", { style: {
                    position: 'absolute',
                    width: '100%',
                    textAlign: 'right',
                    top: '50%',
                    transform: 'translate(0, -50%)',
                } },
                React.createElement(IconButton_1.default, { onClick: function () { return props.onClick(props.track); }, color: 'inherit' },
                    React.createElement(Close_1.default /*colorPrimary='rgb(171, 171, 171)' hoverColor='rgb(255, 255, 255)'*/, null))));
    };
    TrackViewer.TrackHeader = function (props) {
        var iconSize = 32;
        var margin = 16;
        var ArrowElem = props.isExpanded ? ExpandLess_1.default : ExpandMore_1.default;
        var expandArrow = (React.createElement(ArrowElem, { style: {
                marginTop: 8,
                marginLeft: margin,
                color: 'inherit',
            }, viewBox: "0 0 " + iconSize + " " + iconSize }));
        return React.createElement("div", { className: "hpgv_ui-block hpgv_track-header", style: __assign({ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', display: 'flex', alignItems: 'center' }, props.style) },
            props.reorder ?
                React.createElement("div", { style: {
                        position: 'absolute',
                        display: 'block',
                        width: '100%',
                        height: '100%',
                    } },
                    React.createElement("div", { className: "hpgv_track-reorder-button", onClick: function () { return props.moveUp(); }, style: {
                            position: 'absolute',
                            top: 0,
                            width: '100%',
                            textAlign: 'center',
                            cursor: 'pointer',
                            userSelect: 'none',
                        } }, React.createElement(ArrowDropUp_1.default, null)),
                    React.createElement("div", { className: "hpgv_track-reorder-button", onClick: function () { return props.moveDown(); }, style: {
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            textAlign: 'center',
                            cursor: 'pointer',
                            userSelect: 'none',
                        } }, React.createElement(ArrowDropDown_1.default, null)))
                : '',
            props.expandable ? (React.createElement("div", { onClick: function () {
                    props.setExpanded(!props.isExpanded);
                }, style: {
                    cursor: 'pointer',
                    userSelect: 'none',
                    width: iconSize,
                    height: iconSize,
                    // minWidth: iconSize,
                    marginRight: margin,
                } }, expandArrow)) : (React.createElement("div", { style: {
                    width: iconSize,
                    height: iconSize,
                    // minWidth: iconSize,
                    marginRight: margin,
                } })),
            React.createElement("div", { style: {
                    flexGrow: 1,
                    marginRight: margin,
                } }, props.model.name));
    };
    TrackViewer.AddPanelButton = function (props) {
        return React.createElement("div", { className: "hpgv_ui-block hpgv_track-add-button", style: {
                position: 'relative',
                width: '100%',
                height: '100%',
            } },
            React.createElement("div", { style: {
                    position: 'absolute',
                    width: '100%',
                    textAlign: 'right',
                    top: '50%',
                    transform: 'translate(0, -50%)',
                } },
                React.createElement(IconButton_1.default, { onClick: props.onClick, color: "inherit" },
                    React.createElement(Add_1.default, null))));
    };
    return TrackViewer;
}(Object2D_1.default));
exports.TrackViewer = TrackViewer;
var Track = /** @class */ (function () {
    function Track(model, _heightPx, onFieldsChanged) {
        this.model = model;
        this._heightPx = _heightPx;
        this.onFieldsChanged = onFieldsChanged;
        this.closing = false;
        this._opacity = 1.0;
    }
    Object.defineProperty(Track.prototype, "heightPx", {
        get: function () {
            return this._heightPx;
        },
        set: function (v) {
            this._heightPx = v;
            this.onFieldsChanged('heightPx');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Track.prototype, "opacity", {
        get: function () {
            return this._opacity;
        },
        set: function (v) {
            this._opacity = v;
            this.onFieldsChanged('opacity');
        },
        enumerable: true,
        configurable: true
    });
    Track.prototype.applyStyle = function (styleProxy) {
        this.rowObject.applyStyle(styleProxy);
    };
    return Track;
}());
exports.Track = Track;
/**
 * RowObject is a pseudo Object2D used to layout a set of tracks vertically
 * Internal to TrackViewer
 */
var RowObject = /** @class */ (function () {
    function RowObject(model, defaultHeightPx, defaultExpandable, spacing, onClose, onMoveUp, onMoveDown, setHeight, getHeight, reorder) {
        var _this = this;
        this.model = model;
        this.defaultHeightPx = defaultHeightPx;
        this.defaultExpandable = defaultExpandable;
        this.spacing = spacing;
        this.onClose = onClose;
        this.onMoveUp = onMoveUp;
        this.onMoveDown = onMoveDown;
        this.setHeight = setHeight;
        this.getHeight = getHeight;
        this.reorder = reorder;
        this.trackViews = new Set();
        this._opacity = 1.0;
        this._headerIsExpandedState = undefined;
        this.interactionDisabled = false;
        this.isExpanded = function () {
            return _this.getHeight() >= _this.expandedTrackHeightPx;
        };
        this.header = new ReactObject_1.default();
        this.closeButton = new ReactObject_1.default();
        this.resizeHandle = new Rect_1.default(0, 0, [1, 0, 0, 1]);
        this.resizeHandle.h = this.spacing.y;
        this.resizeHandle.z = 1;
        this.resizeHandle.render = false;
        this.setResizable(false);
        this.expandedTrackHeightPx = this.model.expandedHeightPx != null ? this.model.expandedHeightPx : (defaultHeightPx * 2);
        this.updateHeader();
    }
    Object.defineProperty(RowObject.prototype, "y", {
        get: function () { return this._y; },
        set: function (v) { this._y = v; this.layoutY(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowObject.prototype, "h", {
        get: function () { return this._h; },
        set: function (v) {
            this._h = v;
            this.layoutY();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowObject.prototype, "opacity", {
        get: function () {
            return this._opacity;
        },
        set: function (v) {
            this._opacity = v;
            this.syncTrackViews();
            this.updateHeader();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowObject.prototype, "title", {
        get: function () {
            return this.model.name;
        },
        set: function (v) {
            this.model.name = v;
            this.updateHeader();
        },
        enumerable: true,
        configurable: true
    });
    RowObject.prototype.setResizable = function (v) {
        this.resizeHandle.cursorStyle = v ? 'row-resize' : null;
        this.resizeHandle.color = (v ? [0, 1, 0, 1] : [0.3, 0.3, 0.3, 1]);
    };
    RowObject.prototype.addTrackView = function (trackView) {
        this.trackViews.add(trackView);
        this.syncTrackView(trackView);
        this.layoutY();
    };
    RowObject.prototype.removeTrackView = function (trackView) {
        this.trackViews.delete(trackView);
    };
    RowObject.prototype.applyStyle = function (styleProxy) {
        this.styleProxy = styleProxy;
        this.syncTrackViews();
    };
    RowObject.prototype.disableInteraction = function () {
        this.interactionDisabled = false;
        this.updateHeader();
    };
    RowObject.prototype.syncTrackViews = function () {
        var e_34, _a;
        try {
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                this.syncTrackView(view);
            }
        }
        catch (e_34_1) { e_34 = { error: e_34_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_34) throw e_34.error; }
        }
    };
    RowObject.prototype.syncTrackView = function (trackView) {
        if (this.styleProxy != null) {
            trackView.applyStyle(this.styleProxy);
        }
        trackView.opacity = this.opacity;
    };
    /**
     * A TrackRow isn't an Object2D so we manually layout track elements with the track row's y and height
     */
    RowObject.prototype.layoutY = function () {
        var e_35, _a;
        // handle
        var handle = this.resizeHandle;
        handle.originY = -0.5;
        handle.y = this.y + this.h;
        // header
        this.header.y = this.y + this.spacing.y * 0.5;
        this.header.h = this.h - this.spacing.y;
        this.closeButton.y = this.y + this.spacing.y * 0.5;
        this.closeButton.h = this.h - this.spacing.y;
        try {
            // tiles
            for (var _b = __values(this.trackViews), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trackView = _c.value;
                trackView.y = this.y + this.spacing.y * 0.5;
                trackView.h = this.h - this.spacing.y;
            }
        }
        catch (e_35_1) { e_35 = { error: e_35_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_35) throw e_35.error; }
        }
        // update header if expand / collapse-toggle is out of sync with height
        if (this._headerIsExpandedState !== this.isExpanded()) {
            this.updateHeader();
        }
    };
    RowObject.prototype.updateHeader = function () {
        var _this = this;
        this._headerIsExpandedState = this.isExpanded();
        this.header.content = (React.createElement(TrackViewer.TrackHeader, { reorder: this.reorder, model: this.model, expandable: this.model.expandable != null ? this.model.expandable : this.defaultExpandable, isExpanded: this._headerIsExpandedState, setExpanded: function (toggle) {
                if (_this.interactionDisabled)
                    return;
                _this.setHeight(toggle ? _this.expandedTrackHeightPx : _this.defaultHeightPx);
            }, moveUp: function () { return _this.onMoveUp(_this); }, moveDown: function () { return _this.onMoveDown(_this); }, style: {
                opacity: this._opacity,
                pointerEvents: this.interactionDisabled ? 'none' : null
            } }));
        this.closeButton.content = (React.createElement(TrackViewer.TrackCloseButton, { track: this, onClick: function () {
                if (_this.interactionDisabled)
                    return;
                _this.onClose(_this);
            }, style: {
                opacity: this._opacity,
                pointerEvents: this.interactionDisabled ? 'none' : null
            } }));
    };
    return RowObject;
}());
exports.default = TrackViewer;
